export default __webpack_public_path__ + "static/media/predator-crop.52fb793c.jpg";